import util from '@/util'
import tableMixin from '@/mixins/tableMixin'
import ShiftTimeRowsMixin from './ShiftTimeRowsMixin'

export default {
  mixins: [ShiftTimeRowsMixin, tableMixin],
  data() {
    return {
      columns: [
        {
          title: 'Associate', textTitle: 'Associate', dataIndex: 'name', key: 'associate', width: 250,
          scopedSlots: { customRender: 'associate' },
          sorter: (a, b) => {
            const aName = util.combineAssociateName(a.internal_payment_info?.associate?.first_name, a.internal_payment_info?.associate?.last_name)
            const bName = util.combineAssociateName(b.internal_payment_info?.associate?.first_name, b.internal_payment_info?.associate?.last_name)
            return aName == null ? -1 : bName == null ? 1 : aName.localeCompare(bName)
          },
          originalIndex: 1
        },
        { title: 'Company', textTitle: 'Company', key: 'company', width: 200, scopedSlots: { customRender: 'company' }, originalIndex: 2 },
        {
          title: 'Scheduled', textTitle: 'Scheduled', key: 'scheduled', width: 180,
          sorter: (a, b) => this.sortDate(a.scheduled_start, b.scheduled_start),
          customRender: (_, record) => this.getCollectedDate(record, 'scheduled_', record.authorizations_with_status.filter(item => item.status === 'initial').map(item => item.key)), originalIndex: 3
        },
        {
          title: 'Tracked', textTitle: 'Tracked', key: 'actual', width: 180,
          sorter: (a, b) => this.sortDate(a.actual_work_start, b.actual_work_start),
          customRender: (_, record) => this.getCollectedDate(record, 'actual_', record.authorizations_with_status.filter(item => item.status === 'initial').map(item => item.key)), originalIndex: 4
        },
        {
          title: 'Signed', textTitle: 'Signed', key: 'signed', width: 180,
          sorter: (a, b) => this.sortDate(a.work_start, b.work_start),
          customRender: (_, record) => this.getCollectedDate(record, '', record.authorizations_with_status.filter(item => item.status === 'initial').map(item => item.key)), originalIndex: 5
        },
        {
          title: 'Status', textTitle: 'Status', key: 'status', width: 120, scopedSlots: { customRender: 'status' },
          sorter: (a, b) => (a.status == null ? -1 : b.status == null ? 1 : a.status.localeCompare(b.status)), originalIndex: 6
        }
      ]
    }
  },
  computed: {
    isStaff() {
      return Boolean(this.$store.state.applicationState.currentProject?.staffing)
    }
  },
  methods: {
    sortDate(a, b) {
      const dateA = a ? new Date(a) : null
      const dateB = b ? new Date(b) : null
      if (!dateA && !dateB) return 0
      if (!dateA) return 1
      if (!dateB) return -1
      return dateA - dateB
    }
  }
}
